export const getTagNumber = (mbnIcon) => {
    return mbnIcon && mbnIcon.active
        ? mbnIcon.tagNumber
        : undefined;
};
//# sourceMappingURL=getTagNumber.js.map